module.exports = __webpack_public_path__ + "img/블레이드싱어.cd40b423.png";